<script setup>
import Icon from '@/components/shared/icons/Icon.vue'
import {computed, toRefs} from 'vue'

//Emits and props
const props = defineProps({
  type: {
    type: String,
    default: 'info',
  },
  text: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  isSpaced: {
    type: Boolean,
    default: false,
  },
  fitContent: {
    type: Boolean,
    default: false,
  },
})

//Extract props
const {type, icon} = toRefs(props)

//Actual icon
const actualIcon = computed(() => {
  if (icon.value) {
    return icon.value
  }
  switch (type.value) {
    case 'success':
      return 'check_circle'
    case 'warning':
      return 'warning'
    case 'danger':
      return 'error'
    case 'info':
      return 'info'
    default:
      return ''
  }
})
</script>

<template>
  <div
    :class="{
      [$style.message]: true,
      [$style.spaced]: isSpaced,
      [$style.fitContent]: fitContent,
      [$style[type]]: !!type
    }"
  >
    <slot name="contents">
      <Icon
        v-if="actualIcon"
        :icon="actualIcon"
        size="s"
        :class="$style.icon"
        is-outlined
      />
      <span>
        <slot>{{ text }}</slot>
      </span>
    </slot>
  </div>
</template>

<style module lang="scss">
.message {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid var(--color-borders);
  border-radius: var(--border-radius-m);
  a {
    text-decoration: underline;
  }
  &.fitContent {
    width: fit-content;
  }
  &.spaced {
    padding: 1rem;
    justify-content: flex-start;
  }
  &:not(:first-child) {
    margin-top: 1rem;
  }
  &.success {
    border-color: var(--color-borders-success);
    background-color: var(--bg-status-success);
    color: var(--color-text-success);
    .icon, a {
      color: var(--color-text-success);
    }
  }
  &.warning {
    border-color: var(--color-borders-warning);
    background-color: var(--bg-status-warning);
    color: var(--color-text-warning);
    .icon, a {
      color: var(--color-text-warning);
    }
  }
  &.danger {
    border-color: var(--color-borders-danger);
    background-color: var(--bg-status-danger);
    color: var(--color-text-danger);
    .icon, a {
      color: var(--color-text-danger);
    }
  }
  &.info {
    border-color: var(--color-borders-info);
    background-color: var(--bg-status-info);
    color: var(--color-text-info);
    .icon, a {
      color: var(--color-text-info);
    }
  }
}
</style>
